import {useAtom} from 'jotai';
import {useEffect, useRef} from 'react';
import styled from 'styled-components';
import {mapCenterAtom} from '@/map/atom';
import {MAP_LAYER_Z_INDEX} from '@/map/constants';
import {useWatchPosition} from '@/map/hooks';
import {Marker} from '@/map/modules';
import {interceptProps} from '@/styled-components/utils';
import SimpleDot from './assets/simple-dot.svg';

interface IProps {
  map: naver.maps.Map;
}

export const CurrentPosition = ({map}: IProps) => {
  const {active, position, setActive} = useWatchPosition();
  const [center, setCenter] = useAtom(mapCenterAtom);

  const hasPrev = useRef<boolean>(false);

  useEffect(() => {
    if (center && position?.mapsLatLng) {
      const hasLatLng = map.getBounds().hasPoint(position.mapsLatLng);

      if (!hasLatLng) {
        setActive(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [center]);

  useEffect(() => {
    if (position.mapsLatLng && !hasPrev.current) {
      hasPrev.current = true;
      setCenter(position.mapsLatLng);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position]);

  useEffect(() => {
    if (!active) {
      hasPrev.current = false;
    }
  }, [active]);

  useEffect(() => {
    return () => {
      setActive(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (map && active && position?.mapsLatLng) {
    return (
      <Marker
        map={map}
        draggable={false}
        clickable={false}
        position={position?.mapsLatLng}
      >
        <Dot src={SimpleDot} heading={0} />
      </Marker>
    );
  }

  return null;
};

const Dot = styled('img').withConfig({
  shouldForwardProp: interceptProps(['degree']),
})<{
  heading: number; // 정북향 기준 0
}>`
  position: relative;
  transform: rotate(${({heading = 0}) => `${heading + 180}deg`});
  z-index: ${MAP_LAYER_Z_INDEX.LOCATION};
`;
